<template>
  <b-row>    
    <!-- Field -->
    <b-col cols="4" v-if="!hidefield">
      <b-form-select
        v-model="cond.field"
        :options="GetFieldsToSelect()"
        @change="SetField(cond.field)"
        size="sm"
      ></b-form-select>
    </b-col>       
    <!-- Condition type  -->
    <b-col cols="2" v-if="cond.field">
      <b-form-select
        v-model="cond.type"
        :options="GetCondTypesForField(cond.field)"
        size="sm"
        @change="SetCondType(cond.type)"
      ></b-form-select>
    </b-col>
    <!-- Conditions -->
    <b-col v-if="condType && condType.min">
    </b-col>
    <b-col v-if="condType && condType.min">
      <b-input-group size="sm" prepend="Min:" v-if="cond.valtype != 'date'"
        ><b-input
          autofocus
          size="sm"
          value="100"
          v-model="cond.min"
          v-bind:type="cond.valtype"
          @change="setChange()"
        ></b-input
      ></b-input-group>
      <datepicker
        autofocus
        @change="setChange()"
        @input="setChange()"
        v-model="cond.min"
        v-if="cond.valtype == 'date'"
      ></datepicker>
    </b-col>
    <b-col v-if="condType && condType.max">
      <b-input-group size="sm" prepend="Max:" v-if="cond.valtype != 'date'"
        ><b-input
          size="sm"
          value="100"
          v-model="cond.max"
          @change="setChange()"
        ></b-input
      ></b-input-group>
      <datepicker
        @change="setChange()"
        @input="setChange()"
        v-model="cond.max"
        v-if="cond.valtype == 'date'"
      ></datepicker>
    </b-col>
    <b-col v-if="condType && condType.eq">
      <b-input-group size="sm" prepend="=" v-if="cond.valtype != 'date'"
        ><b-input
          autofocus
          v-bind:type="cond.valtype"
          size="sm"
          value="100"
          v-model="cond.eq"
          @change="setChange()"
        ></b-input
      ></b-input-group>
      <datepicker
        @change="setChange()"
        @input="setChange()"
        v-model="cond.eq"
        v-if="cond.valtype == 'date'"
      ></datepicker>
    </b-col>
    <b-col v-if="condType && condType.type == '+-'">
      <b-input-group size="sm" prepend="Värde" v-if="cond.valtype != 'date'"
        ><b-input
          v-bind:type="cond.valtype"
          size="sm"
          value="100"
          v-model="cond.centervalue"
          @change="RecalcMinMax()"
        ></b-input
      ></b-input-group>
    </b-col>
    <b-col v-if="condType && condType.type == '+-'">
      <b-input-group size="sm" prepend="+-" v-if="cond.valtype != 'date'"
        ><b-input
          size="sm"
          value="100"
          v-model="cond.pmvalue"
          @change="RecalcMinMax()"
        ></b-input
      ></b-input-group>
    </b-col>
    <b-col v-if="condType && condType.type == '+-'"
      >({{ cond.min }}-{{ cond.max }})</b-col
    >
    <b-col v-if="condType && condType.list">
      <b-tabs size="sm">
        <b-tab title="Sök" active>
          <!-- <b-panel> -->
          <b-input-group size="sm" prepend="Sök:">
            <b-input
              autofocus
              type="search"
              v-model="searchfor"
              v-on:keydown="sfkeydown"
            ></b-input>
            <b-button
              size="sm"
              title="Lägg till dessa i lista"
              @click="AddFilteredToList()"
              >+</b-button
            >
          </b-input-group>
          <div class="scroll">
            <table>
              <thead>
                <th>
                  <b-icon-check2-square
                    @click="toggleSelected()"
                  ></b-icon-check2-square>
                  <!-- <i class="fa fa-check-square-o fa-lg mt-4"></i> -->
                </th>
                <th>Värde</th>
                <th>Antal</th>
              </thead>
              <tbody>
                <tr
                  v-for="(c, i) in getFilteredDistincts(searchfor, distincts)"
                  :key="i"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="c.chk"
                      @change="toggleSelectInList(c)"
                    />
                    <!-- <b-check v-model="c.chk" @change="setChange()"></b-check> -->
                  </td>
                  <td>{{ c.Value }}</td>
                  <td style="text-align: right">{{ c.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- </b-panel> -->
        </b-tab>
        <b-tab :title="GetValueTabTitle()">
          <b-row>
            <b-input-group size="sm">
              <b-input
                size="sm"
                type="text"
                placeholder="Lägg till värde"
                v-model="vtoadd"
                v-on:keydown="vkeydown"
              ></b-input>
              <b-button size="sm" type="submit" @click="AddNewVal()"
                >+</b-button
              >
              <b-button size="sm" title="Töm lista" @click="ClearList()"
                ><b-icon-x-circle></b-icon-x-circle
              ></b-button>
            </b-input-group>
          </b-row>
          <b-row v-for="(c, i) in cond.list" :key="i">
            <b-col>{{ c }}</b-col>
            <b-col cols="1"
              ><b-icon-x-circle @click="RemoveFromList(c)"></b-icon-x-circle
            ></b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import datepicker from "../../components/datepicker";
import { qvCondition } from "../../lib/qvcondition.js";
const cndLib = new qvCondition();
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "qvcond",
  props: {
    fields: Array,
    cond: Object,
    hidefield: { type: Boolean, default: false },
  },
  components: { datepicker },
  data() {
    return {
      // currField: null,
      condType: null, //Type of condition
      // min: null,
      // max: null,
      // centervalue: null,
      // pmvalue: 0,
      //valtype: null,
      searchfor: null,
      distincts: null,
      vtoadd: null,
    };
  },
  created() {
    //This was disabled before. Why?
    this.RefreshCond();
  },
  watch: {
    cond: function () {
      this.RefreshCond();
    },
  },
  methods: {
    RefreshCond() {
      if (this.cond) {
        if (this.cond.field) this.SetField(this.cond.field);
        if (this.fields.length == 1) this.SetField(this.fields[0].ColName);
        var ct = this.cond.type;
        if (!ct) ct = this.GetCondTypesForField(this.cond.field)[0].value;

        this.SetCondType(ct);
      }
    },
    GetField(fieldName) {
      var i = this.fields.findIndex((x) => x.ColName == fieldName);
      if (i >= 0) return this.fields[i];

      return null;
    },
    GetFieldsToSelect() {
      if (this.fields) {
        var res = [];
        this.fields.map((x) => res.push({ text: x.Name, value: x.ColName }));
        return res;
      }
      return [];
    },
    GetCondTypesForField(colname) {
      var res = [];
      var col = this.GetField(colname);
      if (col) {
        console.log(col);
        cndLib
          .GetCondTypes(col.ColumnType)
          .map((x) => res.push({ text: x.name, value: x.type }));
      }

      return res;
    },
    SetField(fieldName) {
      if (this.cond.field != fieldName) {
        this.cond.field = fieldName;
        this.distincts = null;
      }
      var f = this.GetField(fieldName);
      if (f) this.cond.valtype = this.GetValType(f);
    },
    SetCondType(ct) {
      this.condType = cndLib.GetCondType(ct);
      this.cond.type = this.condType.type;
      //Reset if not used
      if (!this.condType.min && this.condType.type !== "+-")
        this.cond.min = null;
      if (!this.condType.max && this.condType.type !== "+-")
        this.cond.max = null;
      if (!this.condType.eq) this.cond.eq = null;
      if (!this.condType.list) this.cond.list = null;

      if (this.condType.list && !this.distincts) this.RefreshDistincts();
      this.setChange();
    },
    RefreshDistincts() {
      if (this.cond.field) {
        var col = this.GetField(this.cond.field);
        api
          .get(
            "/api/apiqueryview/GetDistincts?" +
              api.params({ id: col.id, filter: this.searchfor })
          )
          .then((res) => {
            this.distincts = res.data;        
          });
      }
    },
    GetValType(f) {
      var tp = cndLib.GetColType(f.ColumnType);
      switch (tp) {
        case "numeric":
          return "number";
          break;
        case "text":
          return "text";
        case "date":
          return "date";
        case "bit":
          return "bit";
      }
      return;
    },
    RecalcMinMax() {
      var c = parseFloat(this.cond.centervalue);
      if (!c) {
        this.cond.min = null;
        this.cond.max = null;
        return;
      }
      var pm = 0;
      if (this.cond.pmvalue) {
        if (this.cond.pmvalue.indexOf("%") > 0)
          pm = (c * parseFloat(this.cond.pmvalue.replace("%", ""))) / 100;
        else pm = parseFloat(this.cond.pmvalue);
      }
      this.cond.min = c - pm;
      this.cond.max = c + pm;
    },
    GetCondition() {
      return this.cond;

      // if (!this.currField || !this.condType) return;
      // //Det här är själva conditionen
      // var res = {
      //   field: this.currField.ColName,
      //   type: this.condType.type,
      //   min: this.min,
      //   max: this.max,
      // };
      // return res;
    },
    GetDisplayText() {
      if (!this.currField || !this.condType) return;
      var res = this.condType.name;

      if (this.condType.eq) res += this.min;

      if (this.condType.max) res += "," + this.max;
      res += ")";
      return res;
    },
    setChange() {
      var c = this.GetCondition();

      if (c) {
        var newVal = c;
        if (!cndLib.IsFiltering(c)) newVal = {};

        this.$emit("change", { cond: this.cond, newvalue: newVal });
      }
    },
    listVisible() {
      return this.condType && this.condType.list;
    },
    getFilteredDistincts(flt, distincts) {
      if (!flt || flt == "" || !distincts) return distincts;

      var v = flt.toString().toLowerCase();
      return distincts.filter(
        (x) => x.Value.toString().toLowerCase().indexOf(v) >= 0
      );
    },
    toggleSelected() {
      var sels = this.getFilteredDistincts(this.searchfor, this.distincts);
      if (sels.length > 0) {
        var v = !sels[0].chk;
        sels.forEach((x) => (x.chk = v));
        this.setChange();
        this.$forceUpdate();
      }
    },
    toggleSelectInList(c) {
      // var sf = c.Value.toLowerCase();
      // if (this.cond.list) {
      //   this.cond.list = this.cond.list.filter((x) => x.toLowerCase() !== sf);
      // }
      this.RemoveFromList(c.Value);
      if (c.chk) {
        if (!this.cond.list) this.cond.list = [];
        this.cond.list.push(c.Value);
      }
      this.setChange();
    },
    AddNewVal(v) {
      if (!this.cond.list) this.cond.list = [];
      if (v) this.cond.list.push(v);
      this.vtoadd = null;
      this.setChange();
    },
    vkeydown(e) {
      if (e.code === "Enter") this.AddNewVal(this.vtoadd);
    },
    sfkeydown(e) {
      if (e.code === "Enter") this.AddFilteredToList();
    },
    AddFilteredToList() {
      var sels = this.getFilteredDistincts(this.searchfor, this.distincts);
      sels.map((x) => {
        x.chk = true;
        this.toggleSelectInList(x);
      });
      this.$forceUpdate();
      this.setChange();
    },
    GetValueTabTitle() {
      var res = "Värden";
      if (this.cond.list && this.cond.list.length > 0)
        res += " (" + this.cond.list.length + ")";
      return res;
    },
    RemoveFromList(value) {
      var sf = value.toString().toLowerCase();
      if (this.cond.list) {
        this.cond.list = this.cond.list.filter(
          (x) => x.toString().toLowerCase() !== sf
        );
        this.$forceUpdate();
        this.setChange();
      }
    },
    ClearList() {
      this.cond.list = null;
      this.distincts.map((x) => (x.chk = false));
      this.$forceUpdate();
      this.setChange();
    },
  },
};
</script>
<style scoped>
.scroll {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>